import { RemoteConfigService } from '@web_opxp/features';
import { UnregisterCallback } from 'history';
import find from 'lodash/find';
import { Dispatch } from 'redux';
import { Actions as UnityActions } from 'web_unity_engine/';
import BalancingConfig from '../base/balancing-config.json';
import ENV from '../base/env';
import { addListener } from '../base/historyService';

const getAccuracyDefaultThresholds = () => {
  const balancingConfig = RemoteConfigService.getObjectConfigValue(ENV.RemoteConfigBalancing, BalancingConfig);
  return balancingConfig?.accuracy_default_thresholds;
};

const getAccuracyGroupThresholds = () => {
  const balancingConfig = RemoteConfigService.getObjectConfigValue(ENV.RemoteConfigBalancing, BalancingConfig);
  return balancingConfig?.accuracy_group_thresholds;
};

export const getMinThreshold = (categoryGroupId: number) => {
  const defaultThresholds = getAccuracyDefaultThresholds();
  const accuracyGroupThresholds = getAccuracyGroupThresholds();
  const accuracyGroupThresholdsByCategoryId = find(accuracyGroupThresholds, ['groupId', categoryGroupId]);
  const groupThresholds = accuracyGroupThresholdsByCategoryId?.thresholds;
  return groupThresholds ? groupThresholds[0] : defaultThresholds?.[0];
};

export const getMaxThreshold = (categoryGroupId: number) => {
  const defaultThresholds = getAccuracyDefaultThresholds();
  const accuracyGroupThresholds = getAccuracyGroupThresholds();
  const accuracyGroupThresholdsByCategoryId = find(accuracyGroupThresholds, ['groupId', categoryGroupId]);
  const groupThresholds = accuracyGroupThresholdsByCategoryId?.thresholds;
  return groupThresholds ? groupThresholds[1] : defaultThresholds?.[1];
};

export const handlePathChange = (dispatch: Dispatch<any>) => {
  // We need to init the variable with let here or else tests will fail
  let handler: UnregisterCallback | undefined = undefined;
  handler = addListener((path: string) => {
    if (!path.startsWith('/exercise')) {
      // Remove unity exercise and unregister listener
      dispatch(UnityActions.unityRemoveExercise());
      if (handler) {
        handler();
      }
    }
  });
};
